import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { GascomService } from '../../../../../services/creditos/gascom.service';

@Component({
  selector: 'estacionario-gascom',
  templateUrl: './estacionario-gascom.component.html',
  styleUrls: ['./estacionario-gascom.component.scss']
})
export class EstacionarioGascomComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public idTipos_Creditos : number = null;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //Cliente form
    public gascom : any = {};
    public errors : any = {};
    private isInitialized : boolean = false;
    //Datepicker
    public fechaInicio: any = null;

    constructor(
      private helperService: HelpersService,
      private gascomService : GascomService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getGascom(this.idCreditos);
        this.isInitialized = true;
      }
    }

    private getGascom(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un aval valido
        this.gascomService.get(idCreditos).subscribe(
          (response)=>
          {
            const gascomArray = response.json().content;
            if(gascomArray.length > 0){
                this.gascom = gascomArray[0];
            }          
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
      }

    public save(){
        this.errors = {};

        let gascom = this.gascom;
        //Asigna el tipo de Crédito. Ya que hay campos que no se requieren para todos los créditos
        this.errors = this.gascomService.validateEstacionario(gascom);

        if (Object.entries(this.errors).length > 0) {
        return false;
        }

        if(gascom.id && gascom.id > 0){
            //Actualiza la información
            this.update(gascom);
        }else{
            //Crear por primera vez el registro referente a la unidad
            this.create(gascom);
        }      
    }

    private create(gascom : any){
        gascom.idCreditos = this.idCreditos;
        this.gascomService.save(gascom).subscribe(
            (response)=>
            {
                this.gascom.id = response.json().content.id;
                this.helperService.notification('Datos gascom actualizados', 'Se han actualizado exitosamente los datos gascom', 'success');
                this.onDataUpdated.emit();
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);
        
                if(error.status == 400) {
                    this.helperService.setBackendErrors(error.json().content, this.errors);
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private update(unidad : any){      
        this.gascomService.update(unidad).subscribe(
            (response)=>
            {
                this.helperService.notification('Datos gascom actualizados', 'Se han actualizado exitosamente los datos gascom', 'success');
                this.onDataUpdated.emit();
            }, error =>
            {
              // se resuelve error 403 y 500
              this.helperService.httpGlobalError(error);
      
              if(error.status == 400) {
                  this.helperService.setBackendErrors(error.json().content, this.errors);
                  this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
              }
            }
        );
      }
}


// WEBPACK FOOTER //
// ./src/app/creditos/credigas-estacionario/detalles/components/gascom/estacionario-gascom.component.ts